export default[
    {
        path: '/rescicao/contrator/lista',
        name: 'lista da recisão contratual', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/rescicao/contrator/cadastro',
        name: 'cadastro da recisão contratual', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/rescicao/contrator/editar/:id',
        name: 'editar da recisão contratual', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]